export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "";
export const SUPABASE_ANON_KEY =
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY || "";

const configuredApiBase = import.meta.env.VITE_API_BASE_URL?.trim();
const isLocalhostApi =
    !configuredApiBase ||
    /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/?$/i.test(configuredApiBase);

export const API_BASE_URL = (
    configuredApiBase || "http://localhost:3001"
).replace(/\/+$/, "");

/** True when a public frontend build is pointed at a loopback API URL. */
export function isMisconfiguredProductionApi(): boolean {
    if (typeof window === "undefined") return false;
    const onLocalhost = /^(localhost|127\.0\.0\.1)$/i.test(
        window.location.hostname,
    );
    return !onLocalhost && isLocalhostApi;
}

export function misconfiguredProductionApiMessage(): string {
    return (
        "This deployment is calling http://localhost:3001, which browsers block from public sites. " +
        "Set VITE_API_BASE_URL to your public backend URL in frontend/.env.production (or Cloudflare Pages env vars) and rebuild."
    );
}
